// =============================================================================
// ACESSO NEGADO POR DOMINIO
// =============================================================================
// Overlay mostrado quando o usuario faz login com um email que nao
// termina em nenhum dos ALLOWED_DOMAINS (src/lib/auth.js). A sessao do
// Supabase ja foi encerrada quando este componente renderiza — esta
// e basicamente uma tela final.
//
// Spec do usuario (paridade com os outros apps do ecossistema):
//   - imagem em https://lh3.googleusercontent.com/d/1-8a2TIePhYZiRMfBhu57Gq2UkIUiuw0N
//   - titulo "ACESSO NEGADO"
//   - pill com o email tentado
//   - botao "Tentar com outra conta" que executa location.href=location.pathname
// =============================================================================

const DENIED_IMG_URL = 'https://lh3.googleusercontent.com/d/1Ecl48aaegGMdGgzCZaTTbv2PXmp7nu-I';

export function AccessDeniedDomain({ email }) {
  const retry = () => {
    // location.href = location.pathname descarta query/hash e recarrega
    // a mesma URL — abre a tela de login limpa pra o user trocar de conta.
    window.location.href = window.location.pathname;
  };

  return (
    <div
      id="access-denied"
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, background: '#0a0e1a', color: '#e8eaf0',
        fontFamily: "'Geist', system-ui, sans-serif",
      }}
    >
      <div style={{
        width: '100%', maxWidth: 460, padding: '36px 32px',
        textAlign: 'center',
        background: '#131825', border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: 16,
      }}>
        <img
          src={DENIED_IMG_URL}
          alt=""
          referrerPolicy="no-referrer"
          style={{
            width: 140, height: 'auto', objectFit: 'contain',
            marginBottom: 20,
          }}
        />

        <h1 style={{
          fontFamily: "'Geist', system-ui, sans-serif",
          fontSize: 22, fontWeight: 700, letterSpacing: '0.04em',
          margin: '0 0 14px', color: '#e8eaf0',
        }}>
          ACESSO NEGADO
        </h1>

        <p style={{
          fontSize: 13.5, color: '#9ba3b4', lineHeight: 1.5,
          margin: '0 0 16px',
        }}>
          Este sistema é exclusivo para contas corporativas autorizadas.
        </p>

        {email && (
          <div
            id="access-denied-email"
            className="font-mono"
            style={{
              display: 'inline-block',
              padding: '6px 12px', borderRadius: 999,
              fontSize: 12.5, fontWeight: 500,
              background: 'rgba(239,90,90,0.12)', color: '#ef5a5a',
              border: '1px solid rgba(239,90,90,0.30)',
              marginBottom: 24,
              maxWidth: '100%',
              wordBreak: 'break-all',
              fontFamily: "'Geist Mono', monospace",
            }}
          >
            {email}
          </div>
        )}

        <div>
          <button
            type="button"
            onClick={retry}
            style={{
              width: '100%', padding: '11px 18px', borderRadius: 12,
              border: 'none', cursor: 'pointer',
              background: '#23c483', color: '#0a0e1a',
              fontWeight: 600, fontSize: 14,
              fontFamily: "'Geist', system-ui, sans-serif",
              transition: 'opacity .15s',
            }}
            onMouseOver={e => { e.currentTarget.style.opacity = '0.9'; }}
            onMouseOut={e => { e.currentTarget.style.opacity = '1'; }}
          >
            Tentar com outra conta
          </button>
        </div>
      </div>
    </div>
  );
}
